import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-buton',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button class="w-btn" [class]="'w-btn w-btn-' + tip()"
            [style.--btn-renk]="renk()"
            (click)="tiklandi.emit()">
      @if (simge()) { <span class="btn-simge">{{ simge() }}</span> }
      <span class="btn-etiket">{{ etiket() }}</span>
    </button>
  `,
  styles: [`
    :host { display: inline-block; }
    .w-btn {
      display: inline-flex; align-items: center; gap: 6px;
      padding: 6px 16px; border-radius: 6px;
      font-size: 13px; font-weight: 500; cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid transparent; outline: none;
      line-height: 1.5;
    }
    .w-btn:active { transform: scale(0.96); }
    .btn-simge { font-size: 15px; line-height: 1; }

    .w-btn-primary {
      background: var(--btn-renk, #1890ff); color: #fff;
      border-color: var(--btn-renk, #1890ff);
    }
    .w-btn-primary:hover { filter: brightness(1.1); }

    .w-btn-default {
      background: transparent;
      color: var(--btn-renk, #1890ff);
      border-color: var(--btn-renk, #1890ff);
    }
    .w-btn-default:hover { background: var(--btn-renk, #1890ff); color: #fff; }

    .w-btn-dashed {
      background: transparent;
      color: var(--btn-renk, #1890ff);
      border: 1px dashed var(--btn-renk, #1890ff);
    }
    .w-btn-dashed:hover { background: var(--btn-renk, #1890ff); color: #fff; }
  `],
})
export class ButonComponent {
  etiket = input('');
  simge = input('');
  renk = input('#1890ff');
  tip = input<'primary' | 'default' | 'dashed'>('primary');
  tiklandi = output<void>();
}
